import { useEffect, useState } from 'react';

const INITIAL_VIEW_STATE = {
  reportParameters: {},
  routeName: ''
};

const useHqReporting = () => {
  const [viewState, setViewState] = useState({ ...INITIAL_VIEW_STATE });

  useEffect(() => {
    setViewState({
      ...viewState,
      reportParameters: {},
      routeName: 'USA_SWIMMING_HQ_REPORTING'
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return { ...viewState };
};

export default useHqReporting;